import React, { lazy, Suspense, useEffect } from 'react';
import { useErrorContext } from 'src/contexts/ErrorContext';
import { useFinishExecution } from 'src/hooks/useFinishExecution';
import { useGetTenantId } from 'src/hooks/useGetTenantId';
import { ErrorCodes } from 'src/types/error';
import { LoadingScreen } from '../LoadingScreen';
import { Logger } from 'src/utils/Logger';
import { SIMPLEUI_EVENT_MAP } from 'src/constants/SimpleUIEvents';
import { ScreenAction } from 'src/analytics/types';
import { publishEvent } from 'src/analytics/publishEvent';
import { useAppTheme } from 'src/contexts/ThemeContext';
import { Container } from './styles';

const TenantSelectorMFE = lazy(() =>
  System.import('@jarvis/react-shell-tenant-selector')
);

export const TenantSelector = () => {
  const { updateError } = useErrorContext();
  const { finishOnSuccess } = useFinishExecution();
  const { getTenantId } = useGetTenantId();
  const { isModal } = useAppTheme();

  useEffect(() => {
    Logger.log('TenantSelector started!');
  }, []);

  const finishTenantSelector = () => {
    // Analytics - send event Simple UI
    publishEvent({ type: ScreenAction.BACK_FROM_TENANT_SELECTOR });
    finishOnSuccess(getTenantId());
  };

  const errorCallback = (error: any) => {
    const message = error.payload?.message
      ? error.payload.message
      : error.message
        ? error.message
        : JSON.stringify(error);

    updateError({ errorCode: ErrorCodes.TenantSelectorError, message });
  };

  // Analytics - send event Simple UI
  publishEvent({ type: ScreenAction.REDIRECT_TO_TENANT_SELECTOR });

  return (
    <Container>
      <Suspense
        fallback={
          <LoadingScreen
            flow={SIMPLEUI_EVENT_MAP.LOADING_SPINNER.PRE_TENANT_SELECTOR}
          />
        }
      >
        <TenantSelectorMFE
          preventReload={true}
          fullscreen={!isModal}
          finishTenantSelector={finishTenantSelector}
          errorCallback={errorCallback}
        />
      </Suspense>
    </Container>
  );
};
